// src/app/services/recaptchaV3.js
export class RecaptchaV3Service {
  constructor() {
    this.siteKey = '6LdHUkksAAAAAFD3TRsA0s54hmDwRwVWY4EbwXs7';
  }

  async genToken(eventDesc) {
    return new Promise((resolve, reject) => {
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(this.siteKey, { action: eventDesc });
          resolve(token);
        } catch (error) {
          reject('error');
        }
      });
    });
  }
}
